import Typography from '@material-ui/core/Typography'
import React from 'react'

export const MyCircleSettings = () => {
  return (
    <div>
      <Typography variant="h4" color="primary">
        My group settings
      </Typography>
    </div>
  )
}
